import React from 'react';
import { Form } from '../../../../../v2BaseComponents/Form';
import { useIsDisabledByParent } from '../../../../../v2BaseComponents/IsDisabledProvider';
import SideDrawerFormContainer, {
    ConfirmDirtyStateFormCloseContainer,
    SideDrawerDirtyFormExitValidationTracker,
} from '../../../../../v2BaseComponents/Form/SideDrawerFormContainer';
import useOrganizationInvitationDefinitions from '../../../../../../hooks/api/useOrganizationInvitationDefinitions';
import FormFields, {
    mapFormValuesToRequest,
    defaultFormValues,
} from '../../../../../shared/InvitationDefinitions/FormFields';

export type AddInvitationDefinitionSideDrawerContentOwnProps = {
    onClose: (force: boolean) => void;
};

export type AddInvitationDefinitionSideDrawerContentProps = AddInvitationDefinitionSideDrawerContentOwnProps;

const AddInvitationDefinitionSideDrawerContent: React.FC<AddInvitationDefinitionSideDrawerContentProps> = ({
    onClose,
}) => {
    const { isCreatingInvitationDefinition, createInvitationDefinition } = useOrganizationInvitationDefinitions({
        onCreateInvitationDefinition: () => onClose(true),
    });
    const isDisabled = useIsDisabledByParent(isCreatingInvitationDefinition);
    return (
        <ConfirmDirtyStateFormCloseContainer>
            <Form
                fillContainer
                initialValues={defaultFormValues}
                onSubmit={(values) => createInvitationDefinition(mapFormValuesToRequest(values))}
                isDisabled={isDisabled}
                forceStackFields
            >
                {({ isSubmitting, handleSubmit, values }) => {
                    return (
                        <SideDrawerFormContainer
                            isDisabled={isDisabled || isSubmitting}
                            onSubmit={handleSubmit}
                            onCancel={() => onClose(true)}
                        >
                            <SideDrawerDirtyFormExitValidationTracker />
                            <FormFields
                                isDisabled={isDisabled || isSubmitting}
                                value={values}
                                initialValues={defaultFormValues}
                            />
                        </SideDrawerFormContainer>
                    );
                }}
            </Form>
        </ConfirmDirtyStateFormCloseContainer>
    );
};

export default React.memo(AddInvitationDefinitionSideDrawerContent);
